import { Component, OnInit } from '@angular/core';
import { AssistBotService } from './assist-bot.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-aiassist',
  templateUrl: './aiassist.component.html',
  styleUrls: ['./aiassist.component.scss']
})
export class AIAssistComponent implements OnInit {

  autoSearchDafaultValue:string="";
  suggestionEnable:boolean=false;
  suggestionList:any=[];
  language:string="eng";
  chatbotData:any=[];
  private readonly notifier: NotifierService;
  constructor(private assistBotService:AssistBotService,private notifierService: NotifierService,) {
    this.notifier = notifierService;
   }

  ngOnInit(): void {
  }


  setautoComplete(value:any){
    this.autoSearchDafaultValue=value['data'];
      if(value['action'] != "Keypress"){
        this.save();
      }
  }

  save(){
   
    if(this.autoSearchDafaultValue.trim()==""){
      this.notifier.notify('default','Please enter your question');
      return;
    }
    let answerData = [{
      "questionId": '',
      "bot_type": "bot",
      "question": this.autoSearchDafaultValue.trim(),
      "answer": "",
      "search":true
    }];
    this.chatbotData.unshift(answerData[0]);
    setTimeout(()=>{
      this.autoSearchDafaultValue="";
      },1500);
  }

}
